"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageLabels = exports.languages = void 0;
var languages;
(function (languages) {
    languages["ENG"] = "eng";
    languages["CMN"] = "cmn";
    languages["HIN"] = "hin";
    languages["SPA"] = "spa";
    languages["ARB"] = "arb";
    languages["BEN"] = "ben";
    languages["FRA"] = "fra";
    languages["RUS"] = "rus";
    languages["POR"] = "por";
    languages["URD"] = "urd";
    languages["IND"] = "ind";
    languages["DEU"] = "deu";
    languages["JPN"] = "jpn";
    languages["MAR"] = "mar";
    languages["TEL"] = "tel";
    languages["TUR"] = "tur";
    languages["TAM"] = "tam";
    languages["YUE"] = "yue";
    languages["WUU"] = "wuu";
    languages["KOR"] = "kor";
    languages["CZE"] = "cze";
    languages["SVK"] = "svk";
    languages["GRE"] = "gre";
    languages["GUJ"] = "guj";
    languages["POL"] = "pol";
    languages["UNSPECIFIED"] = "unspecified";
})(languages || (exports.languages = languages = {}));
exports.languageLabels = {
    [languages.BEN]: 'Bengali',
    [languages.CZE]: 'Czech',
    [languages.DEU]: 'German',
    [languages.ENG]: 'English',
    [languages.FRA]: 'French',
    [languages.GRE]: 'Greek',
    [languages.GUJ]: 'Gujarati',
    [languages.HIN]: 'Hindi',
    [languages.IND]: 'Indonesian',
    [languages.JPN]: 'Japanese',
    [languages.KOR]: 'Korean',
    [languages.CMN]: 'Mandarin Chinese',
    [languages.MAR]: 'Marathi',
    [languages.POL]: 'Polish',
    [languages.POR]: 'Portuguese',
    [languages.RUS]: 'Russian',
    [languages.SPA]: 'Spanish',
    [languages.SVK]: 'Slovak',
    [languages.ARB]: 'Standard Arabic',
    [languages.TAM]: 'Tamil',
    [languages.TEL]: 'Telugu',
    [languages.TUR]: 'Turkish',
    [languages.URD]: 'Urdu',
    [languages.WUU]: 'Wu Chinese',
    [languages.YUE]: 'Yue Chinese',
    [languages.UNSPECIFIED]: 'Unspecified',
};
